import { Status } from '@common/enums/global.enums'

export const TRAINEE_STATUSES = [
	Status.ACTIVE,
	Status.INACTIVE
]
